import { render } from "./DesignPropertyPicker.vue?vue&type=template&id=ec9c94ba"
import script from "./DesignPropertyPicker.vue?vue&type=script&lang=js"
export * from "./DesignPropertyPicker.vue?vue&type=script&lang=js"

import "./DesignPropertyPicker.vue?vue&type=style&index=0&id=ec9c94ba&lang=scss"

import exportComponent from "/app/tmp/360pt/V3/v2026.17.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__